import { Tooltip } from '@mui/material'
import React from 'react'
import DriveFileMoveOutlined from '@mui/icons-material/DriveFileMoveOutlined';
export default function TransferIcon({onClick, tooltipTitle, fontSize,color}) {
  return (
   <>
      <Tooltip title={tooltipTitle}>
                  <DriveFileMoveOutlined
                    style={{ fontSize: fontSize || "1.2rem", cursor: "pointer" }}
                    variant="contained"
                    color= {color?color:"primary"} 
                    onClick={onClick}
                    sx={{color:color?color:"primary"}}
                  />
                </Tooltip>
   </>
  )
}
